// Cookie consent types
export const COOKIE_TYPES = {
  NECESSARY: "necessary",
  ANALYTICS: "analytics",
  MARKETING: "marketing",
  FUNCTIONAL: "functional",
};

// Cookie consent storage key
const CONSENT_COOKIE_NAME = "cookie_consent";
const CONSENT_EXPIRY_DAYS = 365;

export const setCookie = (name, value, days = 30) => {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  const secure = window.location.protocol === "https:" ? ";Secure" : "";
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/;SameSite=Lax${secure}`;
};

export const getCookie = (name) => {
  const nameEQ = name + "=";
  const ca = document.cookie.split(";");
  for (const element of ca) {
    let c = element;
    while (c.startsWith(" ")) c = c.substring(1, c.length);
    if (c.startsWith(nameEQ)) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

export const deleteCookie = (name) => {
  const secure = window.location.protocol === "https:" ? ";Secure" : "";
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;SameSite=Lax${secure}`;
};

export const saveConsentPreferences = (preferences) => {
  const consentData = {
    timestamp: new Date().toISOString(),
    preferences: preferences,
  };
  const encodedValue = encodeURIComponent(JSON.stringify(consentData));
  setCookie(CONSENT_COOKIE_NAME, encodedValue, CONSENT_EXPIRY_DAYS);
};

export const getConsentPreferences = () => {
  const consentCookie = getCookie(CONSENT_COOKIE_NAME);
  if (consentCookie) {
    try {
      const decodedValue = decodeURIComponent(consentCookie);
      return JSON.parse(decodedValue);
    } catch (e) {
      try {
        return JSON.parse(consentCookie);
      } catch (parseError) {
        return null;
      }
    }
  }
  return null;
};

export const hasConsent = (cookieType) => {
  const consent = getConsentPreferences();
  if (!consent) return false;
  if (cookieType === COOKIE_TYPES.NECESSARY) return true;
  return consent.preferences?.[cookieType] === true;
};

export const hasConsentBeenSet = () => {
  return getConsentPreferences() !== null;
};

export const clearConsentPreferences = () => {
  deleteCookie(CONSENT_COOKIE_NAME);
};
